<div class="container bg-white p-3" [ngClass]="loading ? 'visually-hidden': ''">
    <app-doc-properties-list [item]="item"></app-doc-properties-list>
</div>